/* eslint-disable react/forbid-component-props */
import React from 'react';
import { MainStateAccessLayer } from './MainStateAccessLayer';

export function withDomain(WrappedComponent) {
  return class DomainHOC extends React.PureComponent {
    render() {
      const { state } = this.props;
      return <WrappedComponent state={state} selectors={new MainStateAccessLayer(state)} {...this.props} />;
    }
  };
}
